import logo from "./logo.svg";
import "./App.css";
import UploadFolder from "./components";
import UploadVideo from "./components/UploadVideo";
import TestUseSWR from "./components/TestUseSWR";

function App() {
  return (
    <div className="App">
      <h1>Hi...</h1>
      {/* <UploadFolder />
      <UploadVideo /> */}
      {/* <TestUseSWR /> */}
    </div>
  );
}

export default App;
